import React, {Fragment} from "react";
import Button from "./Button";
import classNames from 'classnames';
import ComponentConfig from "./ComponentConfig";
import connect from "react-redux/es/connect/connect";
import {setContent} from "./../../actions/index";
import {ComponentFormatter} from "../../utils/formatters";
import Icon from "./Icon";

const componentEditors = {
    WriteOff: "WriteOffs",
    MoneyTransfer: "TransactionPayment"
}

export default connect(() => ({}),{setContent})((props) => {
    return <Fragment>
        {props.label !== false && !props.icon && <label className="control-label">&nbsp;</label>}
        <ComponentConfig componentName={props.component_type} loader={props.loader}>
            {(cprops) => <Button
                    block={props.block !== undefined ? props.block : true}
                    color="default"
                    className={props.className}
                    size={props.icon ? "xs" : null}
                    tooltip={props.icon ? <Fragment>{ComponentFormatter({component: props.component_type})} adatai</Fragment> : null}
                    onClick={() => {
                        props.setContent(componentEditors[props.component_type] || props.component_type, {[cprops.componentConfig.idfield]: props.component_id});
                    }}
                >
                    {props.icon ? (props.icon !== true ? (props.icon instanceof Object ? (props.icon.type ? <props.icon.type {...props.icon.props} /> : <Icon {...props.icon} />) : <Icon name={props.icon} />) : <Icon lib="fas" name="share"/>) : <Fragment>{ComponentFormatter({component: props.component_type})} adatai</Fragment>}
                </Button>
            }
        </ComponentConfig>
    </Fragment>
});